import { airlockAbi } from './chunk-OAUUC2IW.mjs';
import { createDrift } from '@delvtech/drift';

var ModuleState = /* @__PURE__ */ ((ModuleState2) => {
  ModuleState2[ModuleState2["NotWhitelisted"] = 0] = "NotWhitelisted";
  ModuleState2[ModuleState2["TokenFactory"] = 1] = "TokenFactory";
  ModuleState2[ModuleState2["GovernanceFactory"] = 2] = "GovernanceFactory";
  ModuleState2[ModuleState2["HookFactory"] = 3] = "HookFactory";
  ModuleState2[ModuleState2["Migrator"] = 4] = "Migrator";
  return ModuleState2;
})(ModuleState || {});
var ReadFactory = class {
  /**
   * Creates a new ReadFactory instance for read-only operations
   *
   * @param address - The address of the airlock contract
   * @param drift - Optional Drift instance with read adapter (creates default if not provided)
   *
   * @example
   * ```typescript
   * // Using default drift instance
   * const factory = new ReadFactory(airlockAddress);
   *
   * // Using custom drift instance
   * const customDrift = createDrift({ adapter: customAdapter });
   * const factory = new ReadFactory(airlockAddress, customDrift);
   * ```
   */
  constructor(address, drift = createDrift()) {
    this.airlock = drift.contract({
      abi: airlockAbi,
      address
    });
  }
  /**
   * Retrieves the current state/type of a module in the Doppler system
   *
   * Modules in Doppler serve different roles (token factory, governance factory, etc.)
   * and must be whitelisted before they can be used in pool creation.
   *
   * @param module - The address of the module to check
   * @returns Promise resolving to the module's current state
   *
   * @example
   * ```typescript
   * const state = await factory.getModuleState('0x123...');
   *
   * switch (state) {
   *   case ModuleState.NotWhitelisted:
   *     console.log('Module is not approved for use');
   *     break;
   *   case ModuleState.TokenFactory:
   *     console.log('Module can create tokens');
   *     break;
   *   case ModuleState.GovernanceFactory:
   *     console.log('Module can create governance contracts');
   *     break;
   *   // ... other cases
   * }
   * ```
   */
  async getModuleState(module) {
    return this.airlock.read("getModuleState", {
      module
    });
  }
  /**
   * Retrieves comprehensive deployment data for a Doppler asset
   *
   * This method returns all the key contract addresses and configuration
   * associated with a deployed Doppler token, including:
   * - Numeraire (quote token) used for pricing
   * - Timelock and governance contracts
   * - Liquidity migrator for post-discovery trading
   * - Pool initializer and pool addresses
   * - Sale data (tokens for sale)
   * - Integrator address
   *
   * @param asset - The address of the deployed asset token
   * @returns Promise resolving to complete asset deployment data
   *
   * @example
   * ```typescript
   * const assetData = await factory.getAssetData(tokenAddress);
   *
   * console.log('Asset details:', {
   *   numeraire: assetData.numeraire,
   *   governance: assetData.governance,
   *   pool: assetData.pool,
   *   migrationPool: assetData.migrationPool,
   *   totalSupply: assetData.totalSupply.toString(),
   *   tokensForSale: assetData.numTokensToSell.toString(),
   *   integrator: assetData.integrator
   * });
   * ```
   */
  async getAssetData(asset) {
    return this.airlock.read("getAssetData", {
      asset
    });
  }
};

export { ModuleState, ReadFactory };
//# sourceMappingURL=chunk-N4PZ7ZK7.mjs.map
//# sourceMappingURL=chunk-N4PZ7ZK7.mjs.map